import React, { lazy, Suspense } from 'react';
import PublicRoute from '../../../routes/PublicRoute';
import PrivateRoute from '../../../routes/PrivateRoute';
import { Spinner } from '../../Common/Spinner';
import AlumniProfilePage from './AlumniProfilePage';

const AlumniListTable = lazy(() => import('./List/AlumniListTable'));
const AlumniForm = lazy(() => import('./AlumniForm'));
const AlumniInstructionPage = lazy(() => import('./AlumniInstructionPage'));

const AlumniRouter = (props) => (
  <Suspense fallback={<Spinner />}>
    <PrivateRoute path="/list/alumni" searchString={props.searchString} component={AlumniListTable} exact/>
    <PublicRoute path="/alumni/new/:organization_id/:id?" component={AlumniForm} exact/>
    <PublicRoute path="/alumni/registration/instruction/:organization_id" component={AlumniInstructionPage} exact />
    <PrivateRoute path="/alumni/profile/:id" component={AlumniProfilePage} exact />
  </Suspense>
);

export default AlumniRouter;